import { colors, variables } from "../../../../common/styles";

const { blackTransparent, green, red, darkGrey } = colors;
const THUMB_SIZE = 100;

export default (theme) => ({
    auditImage: {
        height: "100%",
        maxHeight: "calc(100vh - 200px)",
        backgroundColor: "#fafafa",
        overflow: "hidden",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: "block",
        position: "relative",
        height: `calc(50% - ${parseInt(theme.spacing()) * 4}px)`,
        minHeight: `calc(50% - ${parseInt(theme.spacing()) * 4}px)`,
        width: "100%",
        transition: theme.transitions.create("opacity"),
        "&:active": {
            opacity: 0.5
        }
    },
    auditImageDetailContainer: {
        padding: `${theme.spacing(2)} ${theme.spacing(1)}`
    },
    auditImageThumbContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start"
    },
    auditImageIdentifier: {
        backgroundColor: blackTransparent,
        color: theme.palette.common.white,
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        position: "absolute",
        width: "100%",
        bottom: 0
    },
    avatarIdentifier: {
        position: "absolute",
        top: "3px",
        left: "3px",
        zIndex: "1",
        "& > .MuiAvatar-circular": {
            width: THUMB_SIZE / 4,
            height: THUMB_SIZE / 4,
            fontSize: ".80em"
        }
    },
    test: {
        position: "absolute",
        bottom: 16,
        left: 16,
        backgroundColor: "rgba(0,0,0,0.5)",
        padding: "2px 6px",
        borderRadius: 4
    },
    auditImageThumbs: {
        display: "flex",
        flexDirection: "row",
        width: "auto",
        overflow: "auto",
        "& > div": {
            position: "relative",
            cursor: "pointer"
        }
    },
    auditImageThumb: {
        background: "transparent",
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        opacity: 1.0,
        transition: theme.transitions.create("opacity"),
        "&:hover": {
            opacity: 0.7
        },
        "&:active": {
            opacity: 0.5
        }
    },
    fullHeight: {
        height: "100%"
    },
    imageViewController: {
        width: "100%",
        height: "100%",
        position: "relative"
    },
    pdfViewerError: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    pdfLoading: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    openNewTab: {
        backgroundColor: "rgba(255,255,255,0.95)",
        "&:hover": { backgroundColor: "white" },
        boxShadow: 3
    },
    pdfViewContainer: {
        height: "100%",
        width: "100%",
        overflowY: "auto",
        position: "relative",
        padding: 2
    },
    pdfIconContainer: {
        position: "absolute",
        top: 16,
        right: 16,
        zIndex: 3000
    },
    nonMandatoryOverlay: {
        backgroundColor: blackTransparent,
        color: theme.palette.common.white,
        padding: `${theme.spacing(0.5)} ${theme.spacing(3)}`,
        position: "absolute",
        width: "100%",
        bottom: 44,       
        zIndex: 2,
        textAlign: "center",
        fontWeight: 600,
        pointerEvents: "none"
    }
});
